import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { validateReg, validations } from '../../validations';

class Form extends PureComponent {
  constructor(props) {
    super(props);
    this.initialValues = {};
    this.validationFuncs = [];
    if (props.fields && props.render) {
      Object.keys(props.fields).forEach((c) => {
        this.initialValues[c] = props.fields[c].initialValue;
        if (props.fields[c].required) {
          this.validationFuncs.push((values) =>
            values[c] ? {} : { [c]: validations.required.error }
          );
        }
        if (props.fields[c].pattern) {
          this.validationFuncs.push((values) =>
            validateReg(props.fields[c].pattern.reg, values[c])
              ? {}
              : { [c]: props.fields[c].pattern.error }
          );
        }
        if (typeof props.fields[c].validate === 'function')
          this.validationFuncs.push(props.fields[c].validate);
      });
    } else if (props.children) {
      React.Children.forEach(props.children, (c) => {
        if (React.isValidElement(c)) {
          this.initialValues[c.props.name] = c.props.initialValue;
          if (c.props.required) {
            this.validationFuncs.push((values) =>
              values[c.props.name] ? {} : { [c.props.name]: validations.required.error }
            );
          }
          if (c.props.pattern) {
            this.validationFuncs.push((values) =>
              validateReg(c.props.pattern, values[c.props.name])
                ? {}
                : { [c.props.name]: c.props.patternErr }
            );
          }
          if (typeof c.props.validate === 'function') this.validationFuncs.push(c.props.validate);
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { props } = this;
    if (prevProps.fields !== props.fields) {
      this.initialValues = {};
      this.validationFuncs = [];
      if (props.fields && props.render) {
        Object.keys(props.fields).forEach((c) => {
          this.initialValues[c] = props.fields[c].initialValue;
          if (props.fields[c].required) {
            this.validationFuncs.push((values) =>
              values[c] ? {} : { [c]: validations.required.error }
            );
          }
          if (props.fields[c].pattern) {
            this.validationFuncs.push((values) =>
              validateReg(props.fields[c].pattern.reg, values[c])
                ? {}
                : { [c]: props.fields[c].pattern.error }
            );
          }
          if (typeof props.fields[c].validate === 'function')
            this.validationFuncs.push(props.fields[c].validate);
        });
      }
    }
  }

  setRef = (r) => {
    this.form = r;
    if (typeof this.props.innerRef === 'function') this.props.innerRef(r);
  };

  validate = (values) => {
    let errors = {};

    this.validationFuncs.forEach((vFunc) => {
      errors = { ...vFunc(values), ...errors };
    });

    if (this.props.validate) {
      errors = { ...this.props.validate(values), ...errors };
    }

    return errors;
  };

  renderForm = ({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
    <form onSubmit={handleSubmit}>
      {React.Children.map(this.props.children, (child) =>
        React.cloneElement(child, {
          errors,
          touched,
          values,
          onChange: handleChange,
          onBlur: handleBlur,
          onKeyDown: (e) => {
            const { keyCode } = e;
            if (child.props.onKeyDown) {
              child.props.onKeyDown(e);
            }
            if (keyCode === 13) {
              if (this.form) this.form.submitForm();
            }
          },
        })
      )}
    </form>
  );

  render() {
    const { onSubmit, render, initialValues } = this.props;
    return (
      <Formik
        ref={this.setRef}
        initialValues={initialValues || this.initialValues}
        validate={this.validate}
        onSubmit={onSubmit}
      >
        {render || this.renderForm}
      </Formik>
    );
  }
}

Form.propTypes = {
  initialValues: PropTypes.object,
  innerRef: PropTypes.func,
  onSubmit: PropTypes.func,
  validate: PropTypes.func,
  children: PropTypes.node,
  fields: PropTypes.object,
  render: PropTypes.func,
};

Form.defaultProps = {
  onSubmit: () => {},
};

export default Form;
